import axios from "@/api/axiosInstance";
import { FetchEmployeeDirectoryProfileResponse } from "./types";

export const fetchEmployeeDirectoryProfile = async (
  uuid: string,
): Promise<FetchEmployeeDirectoryProfileResponse> => {
  // Member-facing bio endpoint — stage-gated, published-only. The
  // /profiles/{uuid} sibling is the MANAGE-gated admin variant.
  const response = await axios.get<FetchEmployeeDirectoryProfileResponse>(
    `/api/private/employee-directory/${uuid}`,
  );
  return response.data;
};
